module.exports = __webpack_public_path__ + "img/4-4.f1e8a3e6.png";